<ion-card>
    <ion-card-header class="station">
        <ion-card-title class="large-ghost-size">
            <h6 class="station-title">{{infraCharge?.chargeArea?.name}}</h6>
            <div [hidden]="!infraCharge?.chargeArea?.geolocation">
                <p class="station-subtitle">{{infraCharge?.chargeArea?.geolocation | location}}</p>
            </div>
        </ion-card-title>
    </ion-card-header>

    <ion-card-content>
        <ion-grid>
            <ion-row class="plug ion-text-center">
                <ion-col [size]="3" class="xsmall-ghost-size ghost-height" *ngIf="infraCharge?.plug?.iconRef">
                    <ion-thumbnail class="plug-container ghost-hidden">
                        <remote-img [src]="'/api/download/' + infraCharge?.plug?.iconRef"></remote-img>
                    </ion-thumbnail>
                </ion-col>
                <ion-col class="plug-content ion-text-left">
                    <p class="plug-name large-ghost-size" *ngIf="!!infraCharge?.plug?.outletModel">
                        <span class="ghost-hidden">{{'plugType.' + infraCharge?.plug?.outletModel | translate}}</span>
                    </p>
                    <p class="plug-info medium-ghost-size">{{formatChargePointInfos()}}</p>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-card-content>
</ion-card>
